module.exports = __webpack_public_path__ + "img/contactless_payment@2x.6a2c87cb.png";